import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import ComponentPlaceholder from 'components/admin/Helper/ComponentPlaceholder'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import moment from 'moment'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { formValues, getFormSyncErrors, reduxForm, change } from 'redux-form'
import { saveDiscount } from 'redux/discounts'
import { confirmationModal } from 'redux/navigation'
import DiscountProducts from './DiscountProducts'
import getActions from './getActions'

const i18nkey = 'admin.discounts.details.'

const mapStateToProps = (state, ownProps) => {
  const { discountsLoading, discounts } = state.discounts
  return {
    discountsLoading,
    discounts,
    errors: getFormSyncErrors('discount_details')(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      saveDiscount,
      confirmationModal,
    },
    dispatch
  )
}

const validate = (values) => {
  const errors = {}
  if (values.kind === 'percent' && Number(values.value) >= 100)
    errors.value = 'too_high'
  if (!values.name) errors.name = 'code_or_name_required'
  return errors
}

const onChange = (values, dispatch) => {
  if (!values.code) dispatch(change('discount_details', 'one_time_code', false))
}

class DiscountDetails extends React.Component {
  initForm(discounts, discount_id) {
    const { initialize, destroy } = this.props //redux form
    if (discounts && discounts.length > 0 && discount_id) {
      if (discount_id === '+discount') {
      const valid_from = moment()
        .startOf('day')
        .format()
      const valid_until = moment()
        .startOf('day')
        .add(1, 'month')
        .format()
        initialize({
          value: '',
          code: '',
          kind: 'percent',
          productIds: [],
          valid_from,
          valid_until,
          dealers_only: true,
        })
      } else {
        const currentDiscount = discounts.find((d) => d.id === +discount_id)
        if (currentDiscount) {
          initialize({
            ...currentDiscount,
            kind: ['percent', 'amount'].includes(currentDiscount)
              ? currentDiscount.kind
              : 'percent',
          })
        } else {
          destroy()
        }
      }
    }
  }

  componentWillMount() {
    const { discounts } = this.props //redux
    const discount_id = this.props.match.params.discount_id
    this.initForm(discounts, discount_id)
  }

  componentWillReceiveProps(nextProps) {
    const { discounts: newDiscounts } = nextProps // redux
    const { discounts: oldDiscounts, initialized } = this.props //redux
    const newDiscountId = nextProps.match.params.discount_id
    const oldDiscountId = this.props.match.params.discount_id
    if (
      (newDiscounts &&
        oldDiscounts &&
        newDiscounts.length !== oldDiscounts.length) ||
      newDiscountId !== oldDiscountId ||
      !initialized
    )
      this.initForm(newDiscounts, newDiscountId)
  }

  render() {
    console.log('discountDetails')
    const { id, initialized, array } = this.props

    const dark = config.theme.dark

    const title = id
      ? I18n.t(i18nkey + 'edit_discount')
      : I18n.t(i18nkey + 'new_discount')

    if (!initialized)
      return <ComponentPlaceholder title={title} inactive loading={false} />
    return (
      <div
        className={classNames([
          'discountDetails',
          'form',
          'ui',
          dark && 'inverted',
        ])}>
        <ComponentHeader title={title} customActions={getActions(this.props)} />
        <DiscountProducts {...{ array }} />
      </div>
    )
  }
}

DiscountDetails = connect(mapStateToProps, mapDispatchToProps)(DiscountDetails)
DiscountDetails = formValues('id')(DiscountDetails)
DiscountDetails = reduxForm({ form: 'discount_details', validate, onChange })(
  DiscountDetails
)
export default withRouter(DiscountDetails)



// WEBPACK FOOTER //
// ./src/components/admin/Discounts/DiscountDetails.jsx